import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import NestedUserHeader from '../../component/reusable/NestedUserHeader';
import { getCategoryHeirarchy } from '../../redux/getCategoryHeirarchy';
import ViewAdminForm from '../../component/adminComps/ViewAdminForm';
import { getAdminDetailsThunk } from '../../redux/admin/adminSlice';

const ViewAdmin = () => {

 

  return (
    <div >
      <NestedUserHeader 
        index="View Admin"
        root="admins"
        buttonText={'Back to list'}/>
      <ViewAdminForm />
    </div>
  );

};

export default ViewAdmin;
